import React, { Component } from "react";
import { Router } from "react-router-dom";
import { Layout } from "./components";
import Routes from "./Routes";
import { history } from "./utils";

// import StoreContext from "storeon/react/context";
// import store from './store'

class App extends Component {
  componentDidMount = () => {
    document.body.style.userSelect = "none";
    document.body.style.webkitUserSelect = "none";
    document.body.style.webkitTouchCallout = "none";
    document.body.style.MozUserSelect = "none";
    document.body.style.msUserSelect = "none";
  }
  render() {
    return (
      // <StoreContext.Provider value={store}>
        <Layout>
          <Router history={history}>
            <Routes />
          </Router>
        </Layout>
      // </StoreContext.Provider>
    );
  }
}

export default App;
